import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSingleOrder } from "../../../../redux/reduxApi/website/OrdersReduxApi";
import toast from "react-hot-toast";
import { FaArrowLeft } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { FaBox } from "react-icons/fa";
import { FaShippingFast } from "react-icons/fa";
import { FaMoneyBillWave } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { FaPrint } from "react-icons/fa";
import { motion } from "framer-motion";
import { getPartListByIdDataAPi } from "../../../../redux/reduxApi/website/MakeYearModel";
import PrivacyPolicy from "../../homePage/Policy/PrivacyPolicy";
import Ordercancel from "../../homePage/Policy/Ordercancel";

const statusColors = {
  pending: "bg-orange-100 text-orange-800",
  processing: "bg-blue-100 text-blue-800",
  shipped: "bg-indigo-100 text-indigo-800",
  delivered: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
};

export default function ViewOrder() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const OrderData = useSelector((state) => state.order.SingleOrder);
  console.log("OrderData", OrderData);
  const [expandedPolicy, setExpandedPolicy] = useState(false);
  const [expandedReturnSteps, setExpandedReturnSteps] = useState(false);
  const [itemsWithImages, setItemsWithImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(false);

  let billingAddress = {};
  let shippingAddress = {};

  try {
    billingAddress = OrderData?.billingAddress
      ? JSON.parse(OrderData.billingAddress)
      : {};
    shippingAddress = OrderData?.shippingAddress
      ? JSON.parse(OrderData.shippingAddress)
      : {};
  } catch (error) {
    console.error("Error parsing addresses:", error);
  }

  useEffect(() => {
    if (id) {
      dispatch(getSingleOrder(id));
    }
  }, [id, dispatch]);

  // Fetch and merge part images with order items
  useEffect(() => {
    const fetchPartImages = async () => {
      if (!OrderData?.items || OrderData.items.length === 0) return;

      setLoadingImages(true);
      try {
        const itemsData = [];

        // Fetch image data for each part key one by one
        for (const item of OrderData.items) {
          try {
            const partData = await getPartListByIdDataAPi(item.partKey);
            console.log(`Part data for ${item.partKey}:`, partData);
            // Merge item with part data (which includes image)
            const mergedItem = {
              ...item,
              image: partData?.images?.image?.id || item.image, // Use fetched image or fallback to existing
            };
            itemsData.push(mergedItem);
          } catch (error) {
            console.error(`Error fetching part data for ${item.partKey}:`, error);
            // If fetch fails, keep original item
            itemsData.push(item);
          }
        }

        setItemsWithImages(itemsData);
      } catch (error) {
        console.error("Error fetching part images:", error);
        // Fallback to original items if all fetches fail
        setItemsWithImages(OrderData.items);
      } finally {
        setLoadingImages(false);
      }
    };

    fetchPartImages();
  }, [OrderData?.items])
  // Check if order is cancellable (within 24 hours)
  const isCancellable = () => {
    if (!OrderData?.CREATEDTIME) return false;
    const orderDate = new Date(
      OrderData.CREATEDTIME.replace(
        /(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}):(\d{3})/,
        "$1T$2.$3Z"
      )
    );
    const now = new Date();
    const hoursDiff = Math.abs(now - orderDate) / 36e5;
    return hoursDiff <= 24 && OrderData.status === "pending";
  };

  // Check if order is returnable (within 30 days)
  const isReturnable = () => {
    if (!OrderData?.CREATEDTIME) return false;
    const orderDate = new Date(
      OrderData.CREATEDTIME.replace(
        /(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}):(\d{3})/,
        "$1T$2.$3Z"
      )
    );
    const now = new Date();
    const daysDiff = Math.floor((now - orderDate) / (1000 * 60 * 60 * 24));
    return daysDiff <= 30 && OrderData.status !== "cancelled";
  };

  // const handleCancelOrder = async () => {
  //   if (window.confirm("Are you sure you want to cancel this order?")) {
  //     try {
  //       await dispatch(cancelOrder(OrderData.ROWID));
  //       toast.success("Order cancelled successfully");
  //       // Refresh the order data
  //       dispatch(getSingleOrder(id));
  //     } catch (error) {
  //       toast.error("Failed to cancel order");
  //     }
  //   }
  // };

  if (!OrderData) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className=" w-full lg:px-4 md:px-0  mx-auto lg:py-8 md:py-2 sm:py-0 h-[70vh] overflow-y-auto"
    >
      {/* Back button and title */}
      <div className="flex items-center  mb-6">
        <Link to="/account/orders" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors duration-300">
          <FaArrowLeft className="mr-2" /> Back to Orders
        </Link>
        <h1 className="text-4xl font-bold mx-auto text-blue-900 ml-4">
          Order Details
        </h1>
      </div>

      {/* Order status bar */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-6 border border-blue-100">
        <div className="flex flex-col md:flex-row md:items-center justify-between">
          <div className="flex items-center gap-1 mb-4 md:mb-0">
            <div className="bg-blue-50 p-3 rounded-full mr-2">
              <FaBox className="text-blue-600 text-xl" />
            </div>
            <div className="mt-3 ">
              <p className="text-gray-600 text-xl mb-[-2px] font-semibold    ">
                Order{" "}
              </p>
              <p className="font-semibold text-lg">{OrderData.ROWID}</p>
            </div>
          </div>

          <div className="flex items-center mb-4 md:mb-0">
            <div className="bg-blue-50 p-3 rounded-full mr-2">
              <FaShippingFast className="text-blue-600 text-2xl" />
            </div>
            <div>
              <p className="text-gray-600 ml-1 mb-[6%] text-xl font-semibold  ">
                Status
              </p>
              <span
                className={`px-3 py-2  rounded-full text-sm font-medium ${statusColors[OrderData.status] || "bg-gray-100 text-gray-800"
                  }`}
              >
                {OrderData?.status?.charAt(0).toUpperCase() +
                  OrderData.status?.slice(1)}
              </span>
            </div>
          </div>

          <div className="flex items-center  mb-2">
            <div className="bg-blue-50 p-3 rounded-full mb-3 mr-2">
              <FaMoneyBillWave className="text-blue-600 text-2xl" />
            </div>
            <div>
              <p className="text-gray-600 text-xl mb-[-1px] font-semibold  ">
                Total
              </p>
              <p className="font-semibold text-lg">${OrderData.totalAmount}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Action buttons */}

      <div className="bg-white rounded-xl  lg:shadow-md lg:p-10 md:p-0 mb-5  lg:border-none   w-full">
        {/* Left column - Order summary */}
        <div className="lg:col-span-2 ">
          {/* Order items */}
          <div className="bg-white   border rounded-xl  p-6 mb-6">
            <h1 className="text-4xl font-semibold text-blue-900 mb-4  text-center ">
              Order Items
            </h1>
            {loadingImages && itemsWithImages.length === 0 && (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-600">Loading product images...</div>
              </div>
            )}
            <div className="space-y-4">
              {itemsWithImages?.map((product, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-center border-b pb-2 last:border-0 last:pb-0"
                >
                  <div className="w-20 h-20 rounded-lg overflow-hidden border">
                    <img
                      src={product?.image}
                      alt={product?.productName}
                      className="w-full h-full p-1 object-contain group-hover:scale-105 ease-in-out duration-500"
                    />
                  </div>
                  <div className="ml-4 flex-1">
                    <h3 className="font-medium text-gray-900">
                      {product.productName}
                    </h3>
                    <p className="text-sm text-gray-600">
                      Part Key: {product.partKey}
                    </p>
                    <p className="text-sm text-gray-600">
                      SKU: {product.sku || "N/A"}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold">${product.totalPrice?.toFixed(2)}</p>
                    <p className="text-sm text-gray-600">
                      Qty: {product.quantity}
                    </p>
                    <p className="text-sm text-gray-600">
                      ${product.unitPrice?.toFixed(2)}  each
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
            <div className="flex flex-wrap gap-3 mb-6">
              {/* {isCancellable() && (
                <motion.button
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg transition-colors duration-300 flex items-center"
                >
                  <span className="mr-2">Cancel Order</span>
                </motion.button>
              )} */}

              {/* Show these buttons only if status is delivered */}
              {OrderData.status === "delivered" && (
                <>
                  {isReturnable() && (
                    <motion.button
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.98 }}
                      className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors duration-300 flex items-center"
                    >
                      <span className="mr-2">Return Items</span>
                    </motion.button>
                  )}

                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                    className="bg-white border border-blue-500 text-blue-500 hover:bg-blue-50 px-4 py-2 rounded-lg transition-colors duration-300 flex items-center"
                  >
                    <FaPrint className="mr-2" />
                    Print Invoice
                  </motion.button>
                </>
              )}
            </div>
          </div>

          {/* Order summary */}
          <div className="bg-white rounded-xl border p-10 mb-6 w-full">
            <h1 className="text-3xl text-center font-semibold text-blue-900 mb-4">
              Order Summary
            </h1>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Subtotal</span>
                <span>${OrderData.subtotalAmount}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Shipping</span>
                <span>${OrderData.shippingCost}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Tax</span>
                <span>${OrderData.taxAmount || "0.00"}</span>
              </div>
              <div className="flex justify-between pt-2 border-t border-gray-200 mt-2">
                <span className="font-semibold">Total</span>
                <span className="font-semibold">${OrderData.totalAmount}</span>
              </div>
            </div>
          </div>

          {/* Order notes */}
          {OrderData.notes && (
            <div className="bg-white rounded-xl shadow-md p-6 mb-6 w-full">
              <h1 className="text-xl font-semibold text-blue-900 mb-4">
                Order Note
              </h1>
              <p className="text-gray-700 bg-blue-50 p-4 rounded-lg">
                {OrderData.notes}
              </p>
            </div>
          )}

          {/* Return policy */}
          <div className="bg-white rounded-xl border p-10 mb-6 w-full">
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => setExpandedPolicy(!expandedPolicy)}
            >
              <h1 className="text-2xl font-semibold text-blue-900">
                Order Cancellation and Return policy
              </h1>
              <FaInfoCircle
                className={`text-blue-500 transition-transform duration-300 ${expandedPolicy ? "rotate-180" : ""
                  }`}
              />
            </div>

            {expandedPolicy && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="mt-4 text-gray-700 space-y-3 overflow-hidden"
              >
                <Ordercancel/>
              </motion.div>
            )}
          </div>
        </div>

        {/* Right column - Customer info */}
        <div>
          {/* Order information */}
          <div className="bg-white rounded-xl border p-10 mb-6 w-full">
            <h1 className="text-3xl text-center font-semibold text-blue-900 mb-4">
              Order Information
            </h1>
            <div className="space-y-3">
              <div>
                <p className="text-gray-600">Order ID</p>
                <p className="font-medium">{OrderData.ROWID}</p>
              </div>
              <div>
                <p className="text-gray-600">Order Date</p>
                <p className="font-medium">
                  {OrderData.CREATEDTIME
                    ? new Date(
                      OrderData.CREATEDTIME.replace(
                        /(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}):(\d{3})/,
                        "$1T$2.$3Z"
                      )
                    ).toLocaleString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    : "N/A"}
                </p>
              </div>
              <div>
                <p className="text-gray-600">Payment Method</p>
                <p className="font-medium">{OrderData.paymentMethod}</p>
              </div>

              <div>
                <p className="text-gray-600">Tracking Code</p>
                <p className="font-medium">
                  {OrderData.tracking_code || "Not available yet"}
                </p>
              </div>
            </div>
          </div>

          {/* Billing Address */}
          <div className="bg-white rounded-xl border p-10 mb-6 w-full">
            <h1 className="text-3xl text-center font-semibold text-blue-900 mb-4">
              Billing Address
            </h1>
            <div className="text-gray-700">
              <p className="font-medium">
                {billingAddress.fullName || billingAddress.name}
              </p>
              {billingAddress.company && <p>{billingAddress.company}</p>}
              <p>{billingAddress.address1}</p>
              {billingAddress.address2 && <p>{billingAddress.address2}</p>}
              <p>
                {billingAddress.city}, {billingAddress.province_code}{" "}
                {billingAddress.postal_code}
              </p>
              <p>{billingAddress.country}</p>
              {billingAddress.phone && (
                <p className="mt-2">Phone: {billingAddress.phone}</p>
              )}
              {billingAddress.email && <p>Email: {billingAddress.email}</p>}
            </div>
          </div>

          {/* Shipping Address */}
          <div className="bg-white rounded-xl border p-10 mb-6 w-full">
            <h1 className="text-3xl  text-center font-semibold text-blue-900 mb-4">
              Shipping Address
            </h1>
            {shippingAddress.name ? (
              <div className="text-gray-700">
                <p className="font-medium">{shippingAddress.name}</p>
                {shippingAddress.company && <p>{shippingAddress.company}</p>}
                <p>{shippingAddress.address1}</p>
                {shippingAddress.address2 && <p>{shippingAddress.address2}</p>}
                <p>
                  {shippingAddress.city}, {shippingAddress.province_code}{" "}
                  {shippingAddress.postal_code}
                </p>
                <p>{shippingAddress.country}</p>
                {shippingAddress.phone && (
                  <p className="mt-2">Phone: {shippingAddress.phone}</p>
                )}
              </div>
            ) : (
              <div className="text-gray-700">
                <p>Same as billing address</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
